module.exports = __webpack_public_path__ + "static/media/Twitter.fc557b3e.png";